export enum TipoComissaoEnum {
  Fixa = 1,
  Desconto = 2,
}
